import React from "react";
import heroImage from './cover-asf-terrassement.png';
import 'animate.css';

export const Hero = () => {
    return (
        <div
            className="hero min-h-screen w-full"
            style={{
                backgroundImage: `url(${heroImage})`,
            }}>
            <div className="hero-overlay bg-opacity-10"></div>
            <div className="hero-content text-neutral-content text-left flex-col items-left lg:flex-row-reverse" >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
                    <div className="card bg-base-100 w-full max-w-sm md:max-w-md xl:max-w-xl lg:max-w-lg shrink-0 shadow-2xl p-8 xl:p-10 grid-start-1">
                        <div className="card-body">
                            <h1 className="mb-5 text-3xl font-bold text-accent">Votre partenaire de travaux</h1>
                            <p className="mb-5 text-info">Pour tous vos projets de construction, que vous soyez particulier ou professionnel, nous proposons nos services dans tous le pays de Montbéliard, le doubs (25), ainsi que le Territoire de Belfort (90).</p>
                            <div className="flex flex-col items-center justify-around lg:flex-row xl:flex-row gap-2">
                                <button className="btn btn-primary text-white rounded-full animate_animated animate__pulse animate__delay-2s">
                                    <a href="#services">Découvrez nos services</a>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                                    </svg>

                                </button>
                                <button className="btn btn-accent text-white rounded-full animate_animated animate__pulse animate__delay-2s">
                                    <a href="/contact">Nous contacter</a>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}